import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import WithMenuData from 'components/MenuDataHOC';

const GetDynamicNutrationAllergenComponent = props => {
  return (
    <LazyLoaderWrapper
      testId={props?.testId}
      importPath='NUTRITION_ALLERGEN_LANDING_PAGE'
      {...props}
    ></LazyLoaderWrapper>
  );
};

export default WithMenuData(GetDynamicNutrationAllergenComponent);
